import { FormControlLabel, Checkbox } from "@mui/material";

const CheckboxCustom = ({
  value,
  html,
  label,
  error,
  labelPlacement,
  className,
  onChange,
  checked,
  inputClassName,
  disabled=false
}) => {
  return (
    <>
      <div className="relative">
        <FormControlLabel
          className={className}
          value={value}
          onChange={onChange}
          disabled={disabled}
          control={<Checkbox checked={checked} className={inputClassName} />}
          label={
            html ? (
              <span dangerouslySetInnerHTML={{ __html: html }}></span>
            ) : (
              label
            )
          }
          labelPlacement={labelPlacement}
        />

        {error && (
          <span className="text-sm text-red-400 absolute ltr:left-0 rtl:right-0 bottom-[7px]">
            {error}
          </span>
        )}
      </div>
    </>
  );
};
export { CheckboxCustom };